import { Button } from '@mui/material';
import { useState } from 'react';
import { RichTextInput } from 'ra-input-rich-text';
import {
	BooleanInput,
	DateInput,
	Edit,
	ImageField,
	ImageInput,
	NumberInput,
	ReferenceArrayInput,
	ReferenceInput,
	SelectArrayInput,
	SelectInput,
	SimpleForm,
	TextInput,
} from 'react-admin';

const BlogEdit = () => {
	const [htmlMode, setHtmlMode] = useState(false);

	return (
		<Edit redirect={false}>
			<SimpleForm width={'100%'}>
				<ReferenceInput source="expert" perPage={1000} reference="instructor/all" filter={{ active: true, showInSubscription: true }}>
					<SelectInput optionText="name" label="מומחה/ית" fullWidth />
				</ReferenceInput>

				<ReferenceArrayInput reference="tag/all" perPage={100} source="tags" label="תיוגים">
					<SelectArrayInput optionText="name.he" optionValue="_id" fullWidth />
				</ReferenceArrayInput>

				<TextInput source="title.he" label="כותרת (עברית)" dir="rtl" style={{ direction: 'rtl' }} fullWidth />
				<TextInput source="title.en" label="כותרת (אנגלית)" dir="ltr" fullWidth />

				<TextInput source="subtitle.he" label="תת-כותרת (עברית)" dir="rtl" style={{ direction: 'rtl' }} fullWidth />
				<TextInput source="subtitle.en" label="תת-כותרת (אנגלית)" dir="ltr" fullWidth />

				<Button variant="outlined" size="small" onClick={() => setHtmlMode(!htmlMode)} sx={{ mb: 1, alignSelf: 'flex-start' }}>
					{htmlMode ? 'מצב עורך עשיר' : 'מצב HTML'}
				</Button>

				{htmlMode ? (
					<>
						<TextInput source="body.he" label="תוכן HTML (עברית)" dir="rtl" style={{ direction: 'rtl' }} fullWidth multiline minRows={15} />
						<TextInput source="body.en" label="תוכן HTML (אנגלית)" dir="ltr" fullWidth multiline minRows={15} />
					</>
				) : (
					<>
						<RichTextInput source="body.he" label="תוכן (עברית)" fullWidth />
						<RichTextInput source="body.en" label="תוכן (אנגלית)" fullWidth />
					</>
				)}

				<ImageField source="cover_image" label="תמונה נוכחית" />
				<ImageInput source="picture" label="החלפת תמונת כיסוי">
					<ImageField source="src" />
				</ImageInput>

				<NumberInput source="order" label="סדר (מספר נמוך = ראשון)" />
				<NumberInput source="reading_time" label="זמן קריאה (דקות)" />
				<BooleanInput source="published" label="פורסם" />
				<DateInput source="published_at" label="תאריך פרסום" />
			</SimpleForm>
		</Edit>
	);
};

export default BlogEdit;
